import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const IconCard = ({
  width,
  height,
  icon,
  iconHover,
  iconWidth,
  iconHeight,
  title,
  onClick,
  ...props
}) => {
  return (
    <Root
      cardWidth={width}
      cardHeight={height}
      imgLink={icon}
      imgLinkHover={iconHover}
      onClick={onClick}
      {...props}
    >
      {icon && <Image imgLink={icon} imgWidth={iconWidth} imgHeight={iconHeight} />}
      <Title>{title}</Title>
    </Root>
  );
};

IconCard.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  icon: PropTypes.string,
  iconHover: PropTypes.string,
  iconWidth: PropTypes.number,
  iconHeight: PropTypes.number,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

IconCard.defaultProps = {
  width: 150,
  height: 94,
  icon: '',
  iconHover: '',
  iconWidth: 26,
  iconHeight: 26
};

const Image = styled.div`
  display: block;
  width: ${props => props.imgWidth}px;
  min-width: ${props => props.imgWidth}px;
  height: ${props => props.imgHeight}px;
  min-height: ${props => props.imgHeight}px;
  margin: 0 auto 10px;
  background-color: transparent;
  background-image: ${props => `url(${props.imgLink})`};
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
`;

const Title = styled.p`
  padding: 0 4px;
  font-size: 14px;
  text-align: center;
`;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: ${props => props.cardWidth}px;
  height: ${props => props.cardHeight}px;
  padding: 18px 0;
  color: #000;
  background-color: #fff;
  border-radius: 2px;
  cursor: pointer;
  &:hover > ${Image} {
    background-image: ${({ imgLink, imgLinkHover }) =>
      imgLinkHover ? `url(${imgLinkHover})` : `url(${imgLink})`};
    transition: background-image 0.2s linear;
  }
`;

export default IconCard;
